import React from "react";
import {
  Table,
} from "reactstrap";
import ScheduleCheckinUniqueNumberModel from "../../../../utils/models/ScheduleCheckinUniqueNumberModel";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

export default function GuestsList({
  guestsList = [],
  loading = false,
}) {
  return (
    <div style={{ paddingBottom: '10px' }}>
      <div className="table-responsive">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>Número</th>
              <th>ID Participante</th>
              <th>Nome</th>
              <th>E-mail</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <LoadingSkelentonTable lines={10} cols={4} />
            ) : (
              guestsList.map((s, i) => renderRow(i, s))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )

  function renderRow(index = 0, guest = ScheduleCheckinUniqueNumberModel()) {
    return (
      <tr key={index}>
        <td>{guest.serialNumber}</td>
        <td>{guest.guestId}</td>
        <td>{guest.guestName}</td>
        <td>{guest.guestEmail}</td>
      </tr>
    )
  }
}
